import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { aboutInfo } from '@/mocks/videos';

export default function AboutPage() {
  const schemaJson = [
    {
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      name: '关于桔子视频',
      description: aboutInfo.introduction,
      url: 'https://juzi.video/about',
      isPartOf: {
        '@type': 'WebSite',
        name: '桔子视频',
        url: 'https://juzi.video/',
      },
      mainEntity: {
        '@type': 'Organization',
        name: '桔子视频',
        description: aboutInfo.introduction,
        url: 'https://juzi.video/',
        email: aboutInfo.contact.email,
        address: {
          '@type': 'PostalAddress',
          addressLocality: '北京',
          addressRegion: '朝阳区',
          streetAddress: '望京科技园A座',
        },
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'https://juzi.video/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: '关于我们',
          item: 'https://juzi.video/about',
        },
      ],
    },
  ];

  return (
    <>
      <SEO
        title="关于我们 | 桔子视频 - 品牌介绍与联系方式"
        description={aboutInfo.introduction}
        keywords="桔子视频,关于我们,品牌介绍,联系方式,视频聚合平台"
        canonicalUrl="https://juzi.video/about"
        schemaJson={schemaJson}
      />

      <main className="pt-16">
        <div className="max-w-[1200px] mx-auto">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="px-4 md:px-6 pb-14">
            <div className="bg-background-100 rounded-3xl p-6 md:p-12 mb-12">
              <div className="text-center mb-8">
                <div className="w-16 h-16 rounded-2xl bg-primary-500 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-play-circle-fill text-background-50 text-3xl"></i>
                </div>
                <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
                  关于桔子视频
                </h1>
                <p className="text-lg text-foreground-600 font-heading">{aboutInfo.slogan}</p>
              </div>

              <div className="max-w-[800px] mx-auto">
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  {aboutInfo.introduction}
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  {aboutInfo.story}
                </p>
              </div>
            </div>
          </section>

          <section className="px-4 md:px-6 pb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
              核心价值观
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
              {aboutInfo.values.map((v, i) => (
                <div key={i} className="bg-background-100 rounded-2xl p-6 text-center transition-all duration-300 hover:scale-[1.02]">
                  <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
                    <i className="ri-star-fill text-primary-500 text-xl"></i>
                  </div>
                  <h3 className="font-heading text-base font-bold text-foreground-950 mb-2">{v.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{v.description}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="px-4 md:px-6 pb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
              发展历程
            </h2>
            <div className="max-w-[800px] mx-auto">
              <div className="relative">
                <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-200 -translate-x-1/2 hidden md:block"></div>
                <div className="flex flex-col gap-6">
                  {aboutInfo.milestones.map((m, i) => (
                    <div
                      key={i}
                      className={`flex flex-col md:flex-row gap-4 md:gap-8 ${
                        i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                      }`}
                    >
                      <div className={`flex-1 ${i % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                        <div className="bg-background-50 rounded-2xl p-5 inline-block">
                          <span className="text-xs font-bold text-primary-500 bg-primary-100 px-2 py-1 rounded-md">
                            {m.year}
                          </span>
                          <h3 className="font-heading text-base font-bold text-foreground-950 mt-2 mb-1">{m.title}</h3>
                          <p className="text-sm text-foreground-600">{m.description}</p>
                        </div>
                      </div>
                      <div className="hidden md:flex items-center justify-center flex-shrink-0">
                        <div className="w-3 h-3 rounded-full bg-primary-500"></div>
                      </div>
                      <div className="flex-1 hidden md:block"></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          <section className="px-4 md:px-6 pb-14 bg-background-100 py-14">
            <div className="max-w-[1200px] mx-auto">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
                用户口碑
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
                {aboutInfo.reputation.map((r, i) => (
                  <div key={i} className="bg-background-50 rounded-2xl p-6 transition-all duration-300 hover:scale-[1.02]">
                    <div className="flex items-center gap-1 mb-3">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <i key={star} className="ri-star-fill text-secondary-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                      "{r.comment}"
                    </p>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                        <span className="text-primary-500 text-sm font-bold">{r.name[0]}</span>
                      </div>
                      <div>
                        <div className="text-sm font-semibold text-foreground-800">{r.name}</div>
                        <div className="text-xs text-foreground-500">{r.role}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="px-4 md:px-6 pb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
              联系我们
            </h2>
            <div className="max-w-[600px] mx-auto">
              <div className="bg-background-100 rounded-2xl p-6 md:p-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-primary-500 text-lg"></i>
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-foreground-800 mb-1">电子邮箱</div>
                      <a href={`mailto:${aboutInfo.contact.email}`} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">
                        {aboutInfo.contact.email}
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-wechat-line text-primary-500 text-lg"></i>
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-foreground-800 mb-1">微信公众号</div>
                      <span className="text-sm text-foreground-600">{aboutInfo.contact.wechat}</span>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-weibo-line text-primary-500 text-lg"></i>
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-foreground-800 mb-1">官方微博</div>
                      <span className="text-sm text-foreground-600">{aboutInfo.contact.weibo}</span>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-primary-500 text-lg"></i>
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-foreground-800 mb-1">公司地址</div>
                      <span className="text-sm text-foreground-600">{aboutInfo.contact.address}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
}